
//用户接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 * @param { post } data 
 *  
 */

// 新建采购入库
export const addPurchase = (data) => {
    return request.post("/outpatient/addPurchaseInventory", data)
}
// 修改西药采购入库
export const editPurchase = (data) => {
    return request.post("/outpatient/edit", data)
}

// 修改卫材采购入库
export const editeisai = (data) => {
    return request.post("/outpatient/eisaiDoc/edit", data)
}
// 修改中药采购入库
export const editZYPurchase = (data) => {
    return request.post("/outpatient/purctcmdoc/editTcmDoc", data)
}
// 修改西药房采购入库
export const editXYFPurchase = (data) => {
    return request.post("/outpatient/dugDoc/edit", data)
}
// 修改中药房采购入库
export const editZYFPurchase = (data) => {
    return request.post("/outpatient/tcmDoc/edit", data)
}
// 西药库入库信息导出
export const exportAllWmDrugDgs = (params, config = {}) => {
  return request({
    url: '/outpatient/exportAllWmDrugDgs',
    method: 'get',
    params: params,
    responseType: 'blob', // 关键配置
    timeout: 30000,
    ...config
  });
};
// 中药库入库信息导出
export const exportAllZYWmDrugDgs = (params, config = {}) => {
  return request({
    url: '/outpatient/purctcmdoc/exportAllTcmDrugDgs',
    method: 'get',
    params: params,
    responseType: 'blob', // 关键配置
    timeout: 30000,
    ...config
  });
};
//新建结算清单
export const addSettlement = (data) => {
    return request.post("/outpatient/addSettlementApplication", data)
}

//新建药品库存
export const addDrugs = (data) => {
    return request.post("/outpatient/addServiceDrugs", data)
}

//新建药品库存
export const settlement = (data) => {
    return request.post("/outpatient/settlementExamine", data)
}
//采购退货
export const returnOfGoods = (data) => {
    return request.post("/outpatient/returnOfGoods", data)
}
// 新建一条采购计划西药
export const addPurchasingPlan = (data) => {
    return request.post("/outpatient/addPurchasingPlan", data)
}
// 新建一条采购计划中药
export const addPurchasingPlanZY = (data) => {
    return request.post("/outpatient/Tcm/save", data)
}

// 修改西药采购计划
export const editPurchasingPlan = (data) => {
	return request.post("/outpatient/editPurchasingPlan", data)
}
// 修改中药采购计划
export const editPurchasingPlanZY = (data) => {
	return request.post("/outpatient/Tcm/edit", data)
}

//新建采购入库西药
export const addDrugStorage = (data) => {
    return request.post("/outpatient/addDrugStorage", data)
}
//新建采购入库卫材
export const addeisai = (data) => {
    return request.post("/outpatient/eisaiDoc/insert", data)
}
//新建采购入库西药房
export const addXYFDrugStorage = (data) => {
    return request.post("/outpatient/dugDoc/insert", data)
}
//新建采购入库中药房
export const addZYFDrugStorage = (data) => {
    return request.post("/outpatient/tcmDoc/insert", data)
}
//新建采购入库中药
export const addZYDrugStorage = (data) => {
    return request.post("/outpatient/purctcmdoc/addTcmDoc", data)
}
// 采购入库列表
export const getDrugStorage = (data) => {
    return request.post("/outpatient/getDrugStorage", data)
}
// 采购入库西药房列表
export const XYFgetDrugStorage = (params) => {
    return request.get("/outpatient/dugDoc/page", {params})
}

// 查询卫材库入库单列表展示信息-分页
export const eisaiRKList = (data) => {
    return request.post("/outpatient/eisaiDoc/pageList", data )
}
export const eisaiList = (data) => {
    return request.post("/outpatient/eisai/page", data )
}
// 中药采购入库-分页
export const purctcmdocPage = (data) => {
    return request.post("/outpatient/purctcmdoc/pageList", data)
}
// 中药房采购入库-分页
export const ZYFpurctcmdocPage = (params) => {
    return request.get("/outpatient/tcmDoc/page", {params})
}
// 提交审核过单 => 西采购计划
export const toExamine = (data) => {
    return request.post("/outpatient/toExamine", data)
}
// 提交审核过单 => 中采购计划
export const toExamineZY = (data) => {
    return request.post("/outpatient/Tcm/toExamine", data)
}
// 提交审核过单 => 采购退库
export const toRetnExamine = (data) => {
    return request.post("/outpatient/docOut/toRetnExamine", data)
}
// 提交审核过单 => 卫材
export const toWcDrugExamine = (data) => {
    return request.post("/outpatient/eisaiDoc/toExamine", data)
}
// 提交审核过单 => 采购入库xy
export const toDrugExamine = (data) => {
    return request.post("/outpatient/toDrugExamine", data)
}
// 提交审核过单 => 采购入库xyf
export const toXYFDrugExamine = (data) => {
    return request.post("/outpatient/dugDoc/toExamine", data)
}
// 提交审核过单 => 采购入库zy
export const toZYDrugExamine = (data) => {
    return request.post("/outpatient/purctcmdoc/toExamine", data)
}
// 提交审核过单 => 采购入库zyF
export const toZYFDrugExamine = (data) => {
    return request.post("/outpatient/tcmDoc/toExamine", data)
}

// 盘点张林 查询药品盘点主表信息展示-分页
export const stockPage = (data) => {
    return request.post("/outpatient/stock/listStock", data)
}
// 盘点张林 创建盘点任务
export const stockAdd = (data) => {
    return request.post("/outpatient/stock/add", data)
}

// 盘点张林 查询正在进行的盘点明细
export const stockInfo = (data) => {
    return request.post("/outpatient/stock/stockInfo", data)
}

// 盘点张林 查询正在进行的盘点明细
export const stockEditDetail = (data) => {
    return request.post("/outpatient/stock/editDetail", data)
}

// 盘点张林 查询正在进行的盘点明细
export const stockInfoing = (data) => {
    return request.post("/outpatient/stock/stockInfo", data)
}
// 盘点张林 盘点任务状态变更
export const toStockExamine = (data) => {
    return request.post("/outpatient/stock/toStockExamine", data)
}
// 盘点张林 作废盘点任务
export const deleteStock = (params) => {
    return request.get("/outpatient/stock/deleteStock", { params })
}
// 盘点张林 获取查询盘点明细的筛选参数信息
export const getValueStock = (params) => {
    return request.get("/outpatient/stock/selectStockInfo", { params })
}
// 盘点张林 查询正在进行的盘点明细已盘点信息
export const infoIsStocked = (params) => {
    return request.get("/outpatient/stock/infoIsStock", { params })
}
// 盘点张林 查看盘点详情信息
export const detailStock = (params) => {
    return request.get("/outpatient/stock/detailStock", { params })
}


/**
 * 
 * @param { get } params 
 *  
 */

// 药库/药房 采购入库根据药品类型切换中西药卫材 选择药品
export const getAllWare = (data) => {
    return request.post("/outpatient/getWareAllDrug", data)
}
// 药库/药房 采购出库根据药品类型切换中西药卫材 选择药品
export const getCKAllWare = (params) => {
    return request.get("/outpatient/docOut/selectDrug", { params })
}

// 新增药品售价调整
export const addAdjust = (data) => {
    return request.post("/outpatient/drugAdjust/addAdjust", data)
}

// 修改药品售价调整
export const editAdjust = (data) => {
    return request.post("/outpatient/drugAdjust/editAdjust", data)
}
// 药品售价调整查询列表-分页
export const drugAdjustpageList = (data) => {
    return request.post("/outpatient/drugAdjust/pageList", data)
}
// 删除药品售价调整单
export const deleteAdjust = (params) => {
    return request.delete("/outpatient/drugAdjust/deleteAdjust", { params })
}
// 查询药品售价调整详情
export const adjustDetails = (params) => {
    return request.get("/outpatient/drugAdjust/adjustDetails", { params })
}
// 查询调价方式
export const drugAdjustType = (params) => {
    return request.get("/outpatient/drugAdjust/type", { params })
}
// 药品售价调整选择药品
export const drugSelectAdjust = (params) => {
    return request.get("/outpatient/drugAdjust/drugSelect", { params })
}
// 通过id查询生产厂家基本信息
export const getManufacturerById = (params) => {
    return request.get("/outpatient/getManufacturerById", { params })
}
// 西药采购入库根据药品id获取厂家下拉选择框
export const getProdent = (params) => {
    return request.get("/outpatient/getWareCj", { params })
}
// 中药采购入库根据药品id获取厂家下拉选择框
export const getProdentZY = (params) => {
    return request.get("/outpatient/traMedici/getTcmCj", { params })
}
// 卫材采购入库根据药品id获取厂家下拉选择框
export const getProdentEisai = (params) => {
    return request.get("/outpatient/eisai/getEisaiWareCj", { params })
}

// 西药药品剂型
export const getDosageForm = (params) => {
    return request.get("/outpatient/selectDrugDosageForm", { params })
}

// 采购入库方式
export const getPutin = (params) => {
    return request.get("/outpatient/dugDoc/selectPutin", { params })
}
// 出库方式
export const selectOut = (params) => {
    return request.get("/outpatient/dugRetn/selectOut", {params})
}

// 采购计划列表查询西药
export const getPurchasingPlan = (params) => {
    return request.get("/outpatient/getPurchasingPlan", { params })
}

// 采购计划列表查询中药 - 分页
export const tcmPlanList = (data) => {
    return request.post("/outpatient/Tcm/tcmPlanList", data)
}

// 采购计划列表查询中药
export const getPurchasingPlanZY = (params) => {
    return request.get("/outpatient/Tcm/getTcmPlans", { params })
}
// 获取西药采购计划
export const getPlans = (params) => {
    return request.get("/outpatient/getPlans", {params})
}
// 获取中药采购计划
export const getZYPlans = (params) => {
    return request.get("/outpatient/Tcm/getTcmPlans", {params})
}
// 新建采购入库 = > 采购计划 西药
export const getPlanData = (params) => {
    return request.get("/outpatient/getPlanData", {params})
}
// 新建采购入库 = > 采购计划 中药
export const getZYPlanData = (params) => {
    return request.get("/outpatient/Tcm/getTcmPlans", {params})
}
// 用于新建计划采购选择药品西药
export const getWare = (data) => {
    return request.post("/outpatient/getWare", data)
}
// 用于新建计划采购选择药品中药
export const getWareZY = (params) => {
    return request.get("/outpatient/traMedici/page", { params })
}
// 新建入库单时选择卫材信息-查询所有卫材
export const getEisaiWare = (params) => {
    return request.get("/outpatient/eisai/getEisaiWare", {params})
}
// 获取采购计划西药
export const getPlan = (params) => {
    return request.get("/outpatient/getPlan", { params })
}
// 获取采购计划中药
export const getPlanZY = (params) => {
    return request.get("/outpatient/Tcm/detail", { params })
}
// 获取采购入库XY
export const getDrugDetails = (params) => {
    return request.get("/outpatient/getDrugDetails", { params })
}
// 查询中药房入库单信息-分页
export const tcmDocPage = (params) => {
    return request.get("/outpatient/tcmDoc/page", {params})
}

// 查询西药房入库单信息详情
export const getXYFDrugDetails = (params) => {
    return request.get("/outpatient/dugDoc/getDrugDetails", { params })
}
// 查询卫材入库单信息详情
export const geteisaiDetails = (params) => {
    return request.get("/outpatient/eisaiDoc/getEisaiDetails", { params })
}
// 查询中药房入库单信息详情
export const getZYFDrugDetails = (params) => {
    return request.get("/outpatient/tcmDoc/getDrugDetails", { params })
}
// 获取采购入库ZY
export const getZYDrugDetails = (params) => {
    return request.get("/outpatient/purctcmdoc/selTcmDoc", { params })
}

// 获取采购退库
export const getRetnList = (params) => {
    return request.get("/outpatient/docOut/getRetnList", { params })
}
// 获取厂家信息
export const getManufacturer = (params) => {
    return request.get("/outpatient/getManufacturer", { params })
}
// 采购入库模糊查询
export const selecting = () => {
    return request.get("/outpatient/selectStatusAndType")
    }
	
// 供应商列表
export const SupplierEntityList = (params) => {
    return request.get("/outpatient/selectSupplierEntityList", { params })
    }
// 获取药品加成率 => 中药
export const getDocMark = (params) => {
    return request.get("/outpatient/docMark/page", { params })
}
// 获取采购计划通过ID的详情
export const getPlanDrugDetails = (params) => {
    return request.get("/outpatient/getPlanDrugDetails", { params })
}	

//成本金额查询加成率和零售金额
export const getMarkUp = (params) => {
    return request.get("/outpatient/docMark/getById", { params })
}	
// 新增药品基础信息-查询加成率
export const docMarkById = (params) => {
    return request.get("/outpatient/docMark/getById", { params })
}
// 供应商下拉列表
export const selectDropDownList = (params) => {
    return request.get("/outpatient/selectDropDownList", { params })
    }
	
// 采购入库列表
export const selectAll = (params) => {
    return request.get("/outpatient/selectAll", { params } )
    }	
	
// 采购其他入库列表
export const getOther = (params) => {
    return request.get("/outpatient/getOther", { params } )
}
	
// 申请人员工列表
export const selectInformation = (params) => {
    return request.get("/outpatient/selectInformation", { params } )
 }	

// 结算申请列表待条件的分页查询
export const StatusAndSupplier = (params) => {
    return request.get("/outpatient/selectByStatusAndSupplier", { params } )
    }	
	
// 通过药品名称,药品编码模糊查询
export const selectingDrugCode = (params) => {
    return request.get("/outpatient/selectDrugNameAndDrugCode", { params } )
}

// 西药药品明细流向
export const chgDetails = (params) => {
    return request.get("/outpatient/chgDetails/page", { params } )
}

// 通过供应商查询分页查询
export const selectSupplier = (params) => {
    return request.get("/outpatient/selectSupplier", { params } )
}

// 库存列表
export const DrugsList = (params) => {
    return request.get("/outpatient/selectDrugsWarehousingList", { params } )
}

// 药品编码模糊查询
// export const DrugsList = (params) => {
//     return request.get("/outpatient/selectDrugNameAndDrugCode", { params } )
// }

// 效期
export const DateRange = (params) => {
    return request.get("/outpatient/selectPurchaseInventoryByEffectiveDateRange", { params } )
}

// 过期
export const ExpireMedicine = (params) => {
    return request.get("/outpatient/selectExpireMedicine", { params } )
}
// 西药库效期统计接口
export const ExpireWarn = (params) => {
    return request.get("/outpatient/expireWarn", { params } )
}

/**
 * 
 * @param { DELETE } params 
 *  
 */  

// 西药采购计划草稿删除
export const deletePlanData = (params) => {
    return request.delete("/outpatient/deletePlanData", { params })
}
// 中药采购计划草稿删除
export const deletePlanDataZY = (params) => {
    return request.delete("/outpatient/Tcm/deleteTcmPlanData", { params })
}
// 西药采购入库草稿删除
export const deleteBy = (params) => {
    return request.delete("/outpatient/deleteBy", { params })
}
// 西药房采购入库草稿删除
export const deleteXYFBy = (params) => {
    return request.delete("/outpatient/dugDoc/deleteDoc", { params })
}
//卫材采购入库草稿删除
export const deleteEisai = (params) => {
    return request.delete("/outpatient/eisaiDoc/deleteDoc", { params })
}

// zhong药库采购入库草稿删除
export const deleteByZY = (params) => {
    return request.delete("/outpatient/purctcmdoc/deleteTcm", { params })
}
// zhong药房采购入库草稿删除
export const deleteByZYF = (params) => {
    return request.delete("/outpatient/tcmDoc/deleteDoc", { params })
}
// 西药房采购入库草稿删除
export const deleteDoc = (params) => {
    return request.delete("/outpatient/dugDoc/deleteDoc", { params })
}

// 暴露
export default{
	getProdent,
	getWare,getPlans,getPlanDrugDetails,deleteDoc,
	getPurchasingPlan,addPurchasingPlan,toExamine,addDrugStorage,getPlan,getPlanData,editPurchasingPlan,getManufacturer,getDrugDetails,toDrugExamine,getRetnList,
	toRetnExamine,
	addDrugs,selectInformation,
	returnOfGoods,
	selecting,getDosageForm,
	selectingDrugCode,
	addPurchase,editPurchase,deleteBy,deletePlanData,
	DrugsList,
	selectAll,getPutin,
	// selectStatusAndType,
	StatusAndSupplier,
	addSettlement,
	selectSupplier,
	SupplierEntityList,
	selectDropDownList,
	DateRange,
	ExpireMedicine,
	settlement,
	getDrugStorage,getDocMark,chgDetails,ExpireWarn,
	// 其他入库
	getOther,
	// 加成率相关
	getMarkUp
}